import { pointsDistance } from 'utils/getDistance';

function needGeocode(meta, loc) {
  const required = ['city', 'country', 'lat', 'lng'];
  if (!meta || !required.every(key => Boolean(meta[key]))) {
    return true;
  }
  const distance = pointsDistance(meta, loc);
  return distance > 10;
}

export default needGeocode;
